import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Element1y2xoj9fs2s4 as Element } from './Element.mjs';
import {
  NativeInteractiveContainerElement1pn7ly9a3ij8y as NativeInteractiveContainerElement,
  NativeInteractiveElementnutmif7l5rxf as NativeInteractiveElement,
} from './InteractiveElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ElementWithActionClass;
function ElementWithAction() {
  if (ElementWithActionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ElementWithAction', VOID, VOID, [InteractiveElement()]);
    ElementWithActionClass = $;
  }
  return ElementWithActionClass;
}
var ElementWithSecondaryActionClass;
function ElementWithSecondaryAction() {
  if (ElementWithSecondaryActionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ElementWithSecondaryAction', VOID, VOID, [ElementWithAction()]);
    ElementWithSecondaryActionClass = $;
  }
  return ElementWithSecondaryActionClass;
}
var InteractiveElementClass;
function InteractiveElement() {
  if (InteractiveElementClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'InteractiveElement', VOID, VOID, [Element()]);
    InteractiveElementClass = $;
  }
  return InteractiveElementClass;
}
var NativeContainerElementWithSecondaryActionClass;
function NativeContainerElementWithSecondaryAction() {
  if (NativeContainerElementWithSecondaryActionClass === VOID) {
    class $ extends NativeContainerElementWithAction() {
      constructor(context) {
        super(context);
        this.stopWatchingSecondaryAction_1 = null;
        this.secondaryAction_1 = null;
      }
      nativeSetSecondaryAction_hwk8oa_k$(action) {
      }
      set_secondaryAction_uet0qs_k$(value) {
        this.secondaryAction_1 = value;
        this.stopWatchingSecondaryAction_1 = rewatchAction(this, this.stopWatchingSecondaryAction_1, value);
        this.nativeSetSecondaryAction_hwk8oa_k$(value);
      }
      get_secondaryAction_6iem8v_k$() {
        return this.secondaryAction_1;
      }
    }
    initMetadataForClass($, 'NativeContainerElementWithSecondaryAction', VOID, VOID, [ElementWithSecondaryAction()]);
    NativeContainerElementWithSecondaryActionClass = $;
  }
  return NativeContainerElementWithSecondaryActionClass;
}
var NativeContainerElementWithActionClass;
function NativeContainerElementWithAction() {
  if (NativeContainerElementWithActionClass === VOID) {
    class $ extends NativeInteractiveContainerElement() {
      constructor(context) {
        super(context);
        this.stopWatchingAction_1 = null;
        this.action_1 = null;
      }
      nativeSetAction_dc0jqw_k$(action) {
      }
      set_action_2ds022_k$(value) {
        this.action_1 = value;
        this.stopWatchingAction_1 = rewatchAction(this, this.stopWatchingAction_1, value);
        this.nativeSetAction_dc0jqw_k$(value);
      }
      get_action_avldmn_k$() {
        return this.action_1;
      }
    }
    initMetadataForClass($, 'NativeContainerElementWithAction', VOID, VOID, [ElementWithAction()]);
    NativeContainerElementWithActionClass = $;
  }
  return NativeContainerElementWithActionClass;
}
function rewatchAction(_this__u8e3s4, previousRelease, action) {
  if (previousRelease == null)
    null;
  else
    previousRelease();
  var tmp;
  if (action == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = _this__u8e3s4.watchForegroundProcess_2u2sac_k$(action);
  }
  return tmp;
}
var NativeElementWithActionClass;
function NativeElementWithAction() {
  if (NativeElementWithActionClass === VOID) {
    class $ extends NativeInteractiveElement() {
      constructor(context) {
        super(context);
        this.stopWatchingAction_1 = null;
        this.action_1 = null;
      }
      nativeSetAction_dc0jqw_k$(action) {
      }
      set_action_2ds022_k$(value) {
        this.action_1 = value;
        this.stopWatchingAction_1 = rewatchAction(this, this.stopWatchingAction_1, value);
        this.nativeSetAction_dc0jqw_k$(value);
      }
      get_action_avldmn_k$() {
        return this.action_1;
      }
    }
    initMetadataForClass($, 'NativeElementWithAction', VOID, VOID, [ElementWithAction()]);
    NativeElementWithActionClass = $;
  }
  return NativeElementWithActionClass;
}
//region block: exports
export {
  ElementWithAction as ElementWithAction109xd6kw8dlp,
  ElementWithSecondaryAction as ElementWithSecondaryAction1gtvxto5sv58k,
  InteractiveElement as InteractiveElementbmyfh3g220bh,
  NativeContainerElementWithSecondaryAction as NativeContainerElementWithSecondaryActionpxt1q8w6be21,
  NativeElementWithAction as NativeElementWithAction32yo3q41a36ui,
};
//endregion

//# sourceMappingURL=InteractiveElement.mjs.map
